import banner_card_icon_1 from "../../../public_images/BannerCardIcon1.svg";
import banner_card_icon_2 from "../../../public_images/BannerCardIcon2.svg";
import banner_card_icon_3 from "../../../public_images/BannerCardIcon3.svg";
import banner_card_icon_4 from "../../../public_images/BannerCardIcon4.svg";
import banner_card_icon_5 from "../../../public_images/BannerCardIcon5.svg";

export default {
  title: 'Components/Home Carousel/Home Carousel',
  component: 'dda-home-carousel',
  argTypes: {
    bannercardlist: {
      control: 'object',
      description: 'Array of banner card objects with image, title, and description',
    },
    
    custom_class: {
      control: 'text',
      description: 'Additional custom class for the card',
    },
    component_mode: {
      control: 'check',
      options: ['light-mode'],
      description: 'Mode for the banner card (e.g., light-mode)',
    },
    items_in_view: {
      control: { type: 'number', min: 1 },
      description: 'Number of items visible at once',
    }
  },
  parameters: {
    docs: {
      description: {
        component: `
Use the \`dda-home-carousel\` component with a dynamic list of banner items.

\`\`\`html
<dda-home-carousel
  items_in_view="5"
  bannercardlist='[
    {"image_src":"https://example.com/image1.jpg", "image_alt":"image one", "banner_card_title":"Title 1", "banner_card_description":"Desc 1", "banner_card_value":"Banner Card One", "banner_card_name":"bannerCardOne"},
    {"image_src":"https://example.com/image2.jpg", "image_alt":"image two", "banner_card_title":"Title 2", "banner_card_description":"Desc 2", "banner_card_value":"Banner Card Two", "banner_card_name":"bannerCardTwo"}
  ]'
></dda-home-carousel>
\`\`\`
        `,
      },
    },
  },
};

const Template = (args) => {
  const { bannercardlist, cardClick, ...rest } = args;

  const attributes = Object.entries(rest)
    .filter(([_, value]) => value !== undefined && value !== '')
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  const bannercardlistStr = bannercardlist
    ? `bannercardlist='${JSON.stringify(bannercardlist).replace(/'/g, "&apos;")}'`
    : '';

  const markup = `<dda-home-carousel ${attributes} ${bannercardlistStr}></dda-home-carousel>`;

  // Parse the string into a DOM element (without an extra parent div)
  const template = document.createElement('template');
  template.innerHTML = markup.trim();

  const carousel = template.content.firstElementChild;

  return carousel;
};

export const Default = Template.bind({});
Default.args = {
  custom_class: '',
  component_mode: '',
  items_in_view: 5,
  bannercardlist: [
    {
      image_src: banner_card_icon_1,
      image_alt: "image one",
      banner_card_title: "Welcome Banner 1",
      banner_card_description: "Description 1",
      banner_card_id: "bannerCardOne",
      banner_card_value: "bannerCardOne",
      banner_card_name: "bannerCardOne",
    },
    {
      image_src: banner_card_icon_2,
      image_alt: "image two",
      banner_card_title: "Welcome Banner 2",
      banner_card_description: "Description 2",
      banner_card_id: "bannerCardTwo",
      banner_card_value: "bannerCardTwo",
      banner_card_name: "bannerCardTwo",
    },
    {
      image_src: banner_card_icon_3,
      image_alt: "image three",
      banner_card_title: "Welcome Banner 3",
      banner_card_description: "Lorem ipsum, or lipsum as it is sometimes known",
      banner_card_id: "bannerCardThree",
      banner_card_value: "bannerCardThree",
      banner_card_name: "bannerCardThree",
    },
    {
      image_src: banner_card_icon_4,
      image_alt: "image four",
      banner_card_title: "Welcome Banner 4",
      banner_card_description: "Description 4",
      banner_card_id: "bannerCardFour",
      banner_card_value: "bannerCardFour",
      banner_card_name: "bannerCardFour",
    },
    {
      image_src: banner_card_icon_5,
      image_alt: "image five",
      banner_card_title: "Welcome Banner 5",
      banner_card_description: "Description 5",
      banner_card_id: "bannerCardFive",
      banner_card_value: "bannerCardFive",
      banner_card_name: "bannerCardFive",
    },
    {
      image_src: banner_card_icon_2,
      image_alt: "image six",
      banner_card_title: "Welcome Banner 6",
      banner_card_description: "Description 6",
      banner_card_id: "bannerCardSix",
      banner_card_value: "bannerCardSix",
      banner_card_name: "bannerCardSix",
    },
  ],
};
